export default {
  met: "met",
  absent: "absent",
  sick: "sick",
};
